import { render, staticRenderFns } from "./rightNotify.vue?vue&type=template&id=443054e6&scoped=true"
import script from "./rightNotify.vue?vue&type=script&lang=ts"
export * from "./rightNotify.vue?vue&type=script&lang=ts"
import style0 from "./rightNotify.vue?vue&type=style&index=0&id=443054e6&prod&lang=stylus&scoped=true"
import style1 from "./rightNotify.vue?vue&type=style&index=1&id=443054e6&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "443054e6",
  null
  
)

export default component.exports